import React, { ChangeEvent } from "react";
import styled from "styled-components";

interface TextAreaProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  rows?: number;
  disabled?: boolean;
  maxLength?: number;
  name?: string;
  style?: React.CSSProperties;
}

const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: #4a90e2;
  }
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  placeholder = "Enter text...",
  rows = 4,
  disabled = false,
  maxLength,
  name,
  style,
}) => {
  return (
    <StyledTextArea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
      maxLength={maxLength}
      style={style}
      name={name}
    />
  );
};

export default TextArea;
